module.exports = __webpack_public_path__ + "img/bank-bbva.5e879174.jpg";